module.exports = __webpack_public_path__ + "img/icon_order_detail.1988cef1.png";